import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={11}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.565 7.011-4.034 6.987C1.57 15.663-.511 14.46.45 12.795L4.483 5.81C2.95 3.443 4.253.865 6.937.811l-.695 1.203C4.934 4.28 7.71 5.884 9.018 3.616l.695-1.203c1.42 2.67-.286 4.77-3.148 4.598Zm-3.826 5.132L2.15 13.16c-.347.601-1.134.147-.787-.454l.588-1.018c.347-.602 1.134-.148.787.454Z"
      fill="#000"
    />
  </svg>
);

export default SvgComponent;
